<template>
  <div class="view_card">
    <p class="title" v-if="item.showTitle">联系我们</p>
    <div class="contact_item">
      <i class="iconfont icon-dizhi"></i>
      <!-- 百度 -->
      <!--<a :href="`https://api.map.baidu.com/marker?location=${item.data['latitude']},${item.data['longitude']}&title=${item.data.address}&output=html`" style="color:#666">
        {{ item.data.address }}<span v-if="item.data.distance">（距离<span class="dist">{{ item.data.distance }}</span>）</span>
      </a>-->
      <!-- 高德 -->
      <a style="color:#666" :href="`https://uri.amap.com/marker?position=${bMapTransGMap.lng},${bMapTransGMap.lat}&name=${item.data.address}`">{{ item.data.address }}（距离<span class="dist">{{ item.data.distance }}</span>）</a>
    </div>
    <div class="contact_item">
      <i class="iconfont icon-phone"></i>
      <a :href="'tel:'+item.data.tel"  style="color:#666">{{ item.data.tel }}</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "Contact_us",
  props:['item'],
  computed:{
    bMapTransGMap(){
      const lng = this.item['data']['longitude']
      const lat = this.item['data']['latitude']
      let x_pi = 3.14159265358979324 * 3000.0 / 180.0;
      let x = lng - 0.0065;
      let y = lat - 0.006;
      let z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi);
      let theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi);
      let lngs = z * Math.cos(theta);
      let lats = z * Math.sin(theta);
      return {
        lng: lngs,
        lat: lats
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
@import "../static/css/global.styl"
.view_card
  color #333 !important
  padding 20px 10px
  flex-direction column
  align-items flex-start !important

  .title
    margin-bottom 10px

  .contact_item
    margin-top 10px
    display flex
    align-items center
    > span
      line-height 20px
      font-size 14px

    .iconfont
      margin-top 3px
      color #999
      margin-right 10px

    .dist
      color $bgColor
</style>
